import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'language',
  initialState: { language: 'en' },
  reducers: {
    changeLanguage: (state, { payload: { language } }) => {
      if (typeof language !== 'undefined') {
        state.language = language as string;
      }
    },
    setDefaultLanguage: (state, { payload: { language } }) => {
      if (!state) {
        state.language = language as string;
      }
    },
  },
});

export const { changeLanguage, setDefaultLanguage } = slice.actions;

export default slice.reducer;
